<template>
  <SfModalPortal
    modal-id="delete-meeting-modal"
    size="s"
    @opened="openModal"
    @close="closeModal"
  >
    <template #title>{{ copy.title }}</template>

    <template #body>
      <div v-dompurify-html="copy.explanationHtml" class="tw-text-center" />
    </template>

    <template #footer>
      <span class="tw-flex tw-flex-row tw-gap-6">
        <SfButtonDs
          data-testid="delete-meeting-modal-submit"
          variant="danger"
          @click="handleDeleteMeeting"
        >
          {{ copy.deleteButton }}
        </SfButtonDs>
        <SfButtonDs variant="secondary" @click="closeModal"
          >{{ copy.cancelButton }}
        </SfButtonDs>
      </span>
    </template>
  </SfModalPortal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { SfModalPortal } from '@app/shared/vue/components/sf-modal'
import type { Meeting } from '@app/application/client_meetings/types'
import useI18n from '@app/shared/vue/composables/use-I18n'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import * as MeetingsApi from '@app/application/client_meetings/api/meetings'
import { usePastMeetingsStore } from '@app/application/client_meetings/screens/past/stores/past-meetings'

const I18n = useI18n()
const copy = {
  title: I18n.t('client_meetings.delete_meeting_modal.title'),
  explanationHtml: I18n.t(
    'client_meetings.delete_meeting_modal.explanation_html'
  ),
  deleteButton: I18n.t('client_meetings.delete_meeting_modal.delete_button'),
  cancelButton: I18n.t('common.cancel'),
}

const meeting = ref<Meeting | null>(null)

function openModal(params: { meeting: Meeting }) {
  meeting.value = params.meeting
}

function closeModal() {
  meeting.value = null
  window.modalCitizen.closeModalPortal()
}

async function handleDeleteMeeting() {
  if (!meeting.value) return

  await MeetingsApi.delete(meeting.value.id)

  const pastMeetingsStore = usePastMeetingsStore()
  pastMeetingsStore.deleteMeeting(meeting.value.id)

  closeModal()
}
</script>
